
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/primary",
      function () {
        return require("private-next-pages/primary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/primary"])
      });
    }
  